module.exports = "images/goTo.600dca24.png";